var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCameraMoved } from "@/atoms";
import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { LottiePlayer } from "./atoms/LottiePlayer";
import styles from "./TutorialAnimation.module.scss";
export var TutorialAnimation = function () {
    var _a;
    var _b = __read(useState(true), 2), closed = _b[0], setClosed = _b[1];
    useEffect(function () {
        requestAnimationFrame(function () { return setClosed(false); });
    }, []);
    var onComplete = useCallback(function () {
        setClosed(true);
    }, [setClosed]);
    // Close tutorial when user starts moving the camera
    var cameraMoved = useCameraMoved();
    useEffect(function () {
        setClosed(true);
    }, [cameraMoved]);
    return (React.createElement("div", { className: classNames(styles.tutorialAnimation, (_a = {},
            _a[styles.closed] = closed,
            _a)) },
        React.createElement(LottiePlayer, { data: require("@/public_assets/tuto_animation.json"), onComplete: onComplete, completeFrame: 250 })));
};
